import { IsActiveMatchOptions } from '@angular/router';
import { InjectionToken } from '@angular/core';

export const ROUTE_HOME = 'home';
export const ROUTE_LOGOUT_SUCCESS = '#logout=success';

// Utility function for relative paths
export function routePrefix(route: string) {
  return '/' + route;
}

// Utility function for full URL paths
export function fullRoutePrefix(route: string) {
  // check if route already starts with /
  if (route.startsWith('/')) {
    return window.location.origin + route;
  }

  return window.location.origin + '/' + route;
}

export function homeRoutePrefix(route: string) {
  return '/' + ROUTE_HOME + routePrefix(route);
}

// DATE PICKER INPUT FIELD REGEX UTILS
export const DOT_REGEX = /[.]/;
export const DATE_FORMAT_REGEX = /^\d{2}\.\d{2}\.\d{4}$/;
export const DATE_SEPARATOR = '.';
export const EMPTY_STRING = '';
export const EMPTY_DATE_TITLE = '-';
export const DATE_FORMAT_GERMAN = 'DD.MM.YYYY';
export const DATE_FORMAT_BACKEND = 'YYYY-MM-DD';
export const DATE_FORMAT_HEADER = 'EEE, dd. MMMM';
export const GERMAN_LOCALE = 'de-DE';

export const ACTIVE_LINK_MATCH_OPTIONS: IsActiveMatchOptions = {
  paths: 'exact',
  queryParams: 'ignored',
  fragment: 'ignored',
  matrixParams: 'ignored',
};

export const DROPDOWN_TRANSFORMERS = new InjectionToken('DROPDOWN_TRANSFORMERS');
